import React from 'react'
import './home.css'
import './animation.css'
import profilePicture from '../../assets/vcai_profile.png'
import { FaLinkedin, FaGithub, FaEnvelope, FaChevronDown } from 'react-icons/fa';
import { email, github, linkedin } from '../../data/Constants'

function Home() {
  return (
    <div className="home" id="home">
      <div className="home-profilePicture">
        <img src={profilePicture} className="profilePicture-transition"/>
        <div className="home-profilePicture-orangeCircle"/>
      </div>
      <div className="home-introduction">
        <div className="home-introduction-text introduction-typing">
          <h1>Hey there,</h1> 
          <h1>I'm <span className="home-introduction-name">Vincent</span>!</h1>
        </div>
        <div className="home-introduction-socials socials-transition">
          <a href={linkedin} target="_blank" rel="noreferrer"><FaLinkedin/></a>
          <a href={github} target="_blank" rel="noreferrer"><FaGithub/></a>
          <a href={email}><FaEnvelope/></a>
        </div>
        <div className="home-introduction-down down-animation" onClick={() => window.scroll({top: document.getElementById("about").offsetTop, behavior: "smooth"})}>
          <FaChevronDown/>
        </div>
      </div>
    </div>
  )
}

export default Home
